import { createSimplePageStrategy } from './simple-page.strategy-helper';

export const HelpSeoStrategy = createSimplePageStrategy('help', 'help', '/contact-us');
